import type { AdminAiScanPageStatusProps } from "../../models/admin-ai-scans.models";
import { adminAiScansStyles } from "../../styles/admin-ai-scans.styles";

// A missing local folder is different from a successful scan with no findings.
// Partial file errors remain visible beside readable reports rather than replacing the whole page.
const AdminAiScanPageStatus = ({
  loading,
  error,
  issues,
  available,
  hasReports,
  onRefresh,
}: AdminAiScanPageStatusProps) => (
  <div className="space-y-3" data-test="admin-ai-scan-page-status">
    <button
      type="button"
      data-test="admin-ai-scan-refresh"
      className={adminAiScansStyles.button}
      onClick={onRefresh}
      disabled={loading}
    >
      Refresh reports
    </button>
    {loading && (
      <p role="status" className={adminAiScansStyles.muted}>
        Loading scan reports…
      </p>
    )}
    {error && (
      <p role="alert" className="bg-[#FFEAED] p-3 text-sm text-[#BF0002]">
        {error}
      </p>
    )}
    {!loading && !error && !hasReports && (
      <p data-test="admin-ai-scan-empty" className={adminAiScansStyles.panel}>
        {available
          ? "No scan reports are available in this folder."
          : "Reports are unavailable on this backend instance. This scan has not been loaded."}
      </p>
    )}
    {issues.length > 0 && (
      <details className="border border-amber-300 p-3 text-xs" data-test="admin-ai-scan-file-issues">
        <summary className="cursor-pointer">{issues.length} report read issue(s)</summary>
        <ul className="mt-2 space-y-1">
          {issues.map((issue, index) => (
            <li key={`${issue.path}:${index}`} className="break-words">
              {issue.path}: {issue.message}
            </li>
          ))}
        </ul>
      </details>
    )}
  </div>
);

export default AdminAiScanPageStatus;
